"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _constants = require("./constants");
var _SpotIllustration = require("./SpotIllustration.utils");
var _SpotIllustration2 = require("./SpotIllustration.types");
var _excluded = ["className", "flip", "name", "size", "style"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var styles = {
  "image": "U9FfcN",
  "horizontal": "HP2o7k",
  "vertical": "eAsEAK",
  "flip": "_0k0w3o",
  "size": "SzYpD6",
  "mobile": "n2VYpr",
  "tablet": "kQg2Qz",
  "desktop": "jVEQCv"
};
var getSpotIllustrationSize = function getSpotIllustrationSize(size) {
  return (0, _SpotIllustration.getDimensionsBySize)(size) || (0, _SpotIllustration.getDimensionsBySize)(_SpotIllustration2.Size.MEDIUM);
};
var getSpotIllustrationDimensions = function getSpotIllustrationDimensions(name, size) {
  return {
    width: (0, _SpotIllustration.isVerticalIllustration)(name) ? 'auto' : getSpotIllustrationSize(size),
    height: (0, _SpotIllustration.isHorizontalIllustration)(name) ? 'auto' : getSpotIllustrationSize(size)
  };
};
var getSpotIllustrationStyle = function getSpotIllustrationStyle(name, size) {
  if (typeof size === 'string') {
    var _getSpotIllustrationD = getSpotIllustrationDimensions(name, size),
      width = _getSpotIllustrationD.width,
      height = _getSpotIllustrationD.height;
    return {
      '--width': width,
      '--height': height
    };
  }
  var responsiveStyle = {};
  if (_typeof(size) === 'object' && size.mobile) {
    var _getSpotIllustrationD2 = getSpotIllustrationDimensions(name, size.mobile),
      _width = _getSpotIllustrationD2.width,
      _height = _getSpotIllustrationD2.height;
    responsiveStyle['--width-mobile'] = _width;
    responsiveStyle['--height-mobile'] = _height;
  }
  if (_typeof(size) === 'object' && size.tablet) {
    var _getSpotIllustrationD3 = getSpotIllustrationDimensions(name, size.tablet),
      _width2 = _getSpotIllustrationD3.width,
      _height2 = _getSpotIllustrationD3.height;
    responsiveStyle['--width-tablet'] = _width2;
    responsiveStyle['--height-tablet'] = _height2;
  }
  if (_typeof(size) === 'object' && size.desktop) {
    var _getSpotIllustrationD4 = getSpotIllustrationDimensions(name, size.desktop),
      _width3 = _getSpotIllustrationD4.width,
      _height3 = _getSpotIllustrationD4.height;
    responsiveStyle['--width-desktop'] = _width3;
    responsiveStyle['--height-desktop'] = _height3;
  }
  return responsiveStyle;
};
var Image = exports.Image = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref2;
  var className = _ref.className,
    flip = _ref.flip,
    name = _ref.name,
    size = _ref.size,
    style = _ref.style,
    props = _objectWithoutProperties(_ref, _excluded);
  var horizontal = (0, _SpotIllustration.isHorizontalIllustration)(name);
  var vertical = (0, _SpotIllustration.isVerticalIllustration)(name);
  return /*#__PURE__*/(
    // eslint-disable-next-line jsx-a11y/alt-text
    _react["default"].createElement("img", _extends({
      ref: ref,
      className: (0, _clsx["default"])(className, _constants.CLASSNAME_SPOT_ILLUSTRATION, styles.image, horizontal && styles.horizontal, vertical && styles.vertical, flip && styles.flip, typeof size === 'string' && styles.size, _typeof(size) === 'object' && (_ref2 = {}, _defineProperty(_ref2, styles.mobile, styles.mobile), _defineProperty(_ref2, styles.tablet, styles.tablet), _defineProperty(_ref2, styles.desktop, styles.desktop), _ref2)),
      style: _objectSpread(_objectSpread({}, getSpotIllustrationStyle(name, size)), style)
    }, props))
  );
});